module.exports = __webpack_public_path__ + "media/demo_linebot/qrcode-58d486d7.png";